module.exports = __webpack_public_path__ + "static/media/close.ad4426dd.svg";